import React, { useState } from "react";
import { confirmLotsPayments } from "../../../../../redux/action/confirmLotspayment";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notifyError } from "../../../../../helpers/helpers";
import SeviceLotForSelectId from "../tables/SeviceLotForSelectId";

function ServiceLotCollection() {
  const { id } = useParams();
  const [checkedValue, setCheckedValue] = useState([]);
  const [remainUncheck, setRemainUncheck] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { singleAuctionData } = useSelector((pre) => pre?.singleAuction);
  const handleSubmitToConfirm = () => {
    if (singleAuctionData?.catalogue?.industryApproval?.status !== "approval") {
      return notifyError("Please wait for catalogue approval.");
    }

    dispatch(confirmLotsPayments(checkedValue, remainUncheck));
    navigate(`/service-reverse-auction/confirm-lots-payment/${id}/${singleAuctionData?.auctionId}`);
  };


  return (
    <div className="cover pin-top p-1 white flex column gap-1">
      <h5 className="margin-0px">List of Lot’s</h5>
      <SeviceLotForSelectId
        checkedValue={checkedValue}
        setCheckedValue={setCheckedValue}
        setRemainUncheck={setRemainUncheck}
      />
      {checkedValue?.length !== 0 && (
        <div className=" flex justify-center">
          <button
            className={`button-style  pointer ${checkedValue?.length === 0
              ? "cover grey lighten-2 grey-text"
              : "white-text cercle-purple"
              }`}
            style={{ padding: "12px 35px" }}
            disabled={checkedValue?.length === 0}
            onClick={handleSubmitToConfirm}
          >
            Proceed
          </button>
        </div>
      )}
    </div>
  );
}

export default ServiceLotCollection;
